import { defaultApi } from '@mint-sdk/api-core';
import type { z } from 'zod';

import type { FilterMappingSchema } from '../shared/schemas/filterMappings.js';
import {
  TaxonomyQuerySchema,
  TaxonomyResponseSchema,
  type TaxonomyItemSchema,
} from '../shared/schemas/taxonomy.js';
import type { TrackerMappingSchema } from '../shared/schemas/trackerMappings.js';

export const getTaxonomy = defaultApi.declareEndpoint({
  url: 'omni-trafficking/v1/taxonomy/' as const,
  method: 'GET',
  responseSchema: TaxonomyResponseSchema,
  querySchema: TaxonomyQuerySchema,
  snakeCaseQueryParams: true,
});

export type TaxonomyItem = z.infer<typeof TaxonomyItemSchema>;
export type TaxonomyResponse = z.infer<typeof TaxonomyResponseSchema>;
export type TaxonomyQueryParams = z.infer<typeof TaxonomyQuerySchema>;
export type TrackerMappingType = z.infer<typeof TrackerMappingSchema>;
export type FilterMappingType = z.infer<typeof FilterMappingSchema>;

export {
  FilterLevelSchema,
  TrackerLevelSchema,
  type FilterLevelTaxonomyItem,
  type TrackerLevelTaxonomyItem,
} from '../shared/schemas/taxonomy.js';
export { RowLevelEnum } from '../shared/schemas/rowLevel.js';
